module.exports = __webpack_public_path__ + "img/motorway_5x3_z18.5786469f.svg";